var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-lead-dialog',{staticClass:"w-full",attrs:{"refetch-parent":_vm.refetchParent},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }